<template>
    <v-container>
        <v-simple-table class="px-8">
            
            <template v-slot:top>
                <v-toolbar flat color="white">
                    <v-toolbar-title>Números de Telefones como trote</v-toolbar-title>
                </v-toolbar>
                <v-divider class="mt-0 mb-5"></v-divider>
            </template>
            
            <template v-slot:default>
                <thead style="background-color:#F5F5F9;">
                    <tr>
                        <th :class="`text-${header.align}`" style="color:#6C7293" v-for="(header,index) in headers" :key="index">{{header.text}}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="item in numbersPhone" :key="item.number">
                        <td style="color:#6C7293">
                            <span class="font-weight-bold">{{ item.number }}</span>
                        </td>
                        <td class="text-right" style="color:#6C7293">
                            <span >{{ item.total }}</span>
                        </td>
                        <td class="text-right" style="color:#6C7293">
                            <span >{{ item.updatedAt }}</span>
                        </td>
                    </tr>
                </tbody>
            </template>
        </v-simple-table>
    </v-container>
</template>

<script>
export default {
    data:()=>({
        headers: [
                {text: 'Número', align: 'start', sortable: false, value: 'number',},
                { text: 'Total de ligaçoes', align: 'end', value: 'total', sortable: false },
                { text: 'Última ligação', align: 'end',value: 'updatedAt', sortable: false },
        ],
        numbersPhone:[
            {number:"(92) 99130-7846", total:20,updatedAt:"03/08/2020"},
            {number:"(92) 99330-3896", total:38,updatedAt:"065/08/2020"},
            {number:"(92) 99898-3422", total:87,updatedAt:"07/08/2020"},
            {number:"(92) 99657-5432", total:13,updatedAt:"08/08/2020"},
            {number:"(92) 99130-7846", total:12,updatedAt:"03/08/2020"},
            {number:"(92) 99330-3896", total:11,updatedAt:"065/08/2020"},
            {number:"(92) 99898-3422", total:5,updatedAt:"07/08/2020"},
            {number:"(92) 99657-5432", total:2,updatedAt:"08/08/2020"},
        ]
    }),
    computed:{
        
    },
    methods:{
        
    }
}
</script>

<style>
</style>